import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";
import { isOpenEndedMessageCount } from "./messageCountSliderState";

export const MessageCountChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);
    const minMessageCount = applicationFiltersStore.minMessageCount ?? 0;
    const maxMessageCount = applicationFiltersStore.maxMessageCount ?? 0;
    const chipLabel =
        minMessageCount === 0 && maxMessageCount === 0
            ? "Message Count: Any Count"
            : isOpenEndedMessageCount(minMessageCount, maxMessageCount)
              ? // Reaches as far as the filter goes -- the last message count bucket's range, and
                // equally a range the user dragged to the end of the track themselves.
                `Message Count: ${minMessageCount}+`
              : `Message Count: ${minMessageCount}–${maxMessageCount}`;

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() => applicationFiltersStore.setMessageCount([])}
        >
            {chipLabel}
        </AppliedFilterChip>
    );
});
